// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".number-input[data-v-d35edde4] input::-webkit-inner-spin-button,.number-input[data-v-d35edde4] input::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.number-input[data-v-d35edde4] .v-text-field__suffix{color:gray!important}.number-input input[type=number][data-v-d35edde4]{-moz-appearance:textfield}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
